import { type ForwardedRef, type MutableRefObject, useRef } from "react";

export const useForwardedOrLocalRef = <T>(forwarededRef: ForwardedRef<T>) => {
  const localRef = useRef(null) as never as MutableRefObject<T>;
  return (forwarededRef ?? localRef) as MutableRefObject<T>;
};
